import { getLexicalArgKeys } from '../getLexicalArgKeys.js';

const formatLexicalUrl = (urlValue) => {
  if (!urlValue || typeof urlValue !== 'object') {
    return null;
  }

  const parts = getLexicalArgKeys(urlValue);
  if (!parts || parts.length === 0) {
    return null;
  }

  let urlText = '';
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    if (part.type === 'block') {
      return null;
    }
    if (part.type === 'text') {
      urlText += part.value || '';
    }
  }

  urlText = urlText.trim();
  return urlText || null;
};

const evaluateHttpRequestMessage = ({ args }) => {
  const method = args?.method || 'GET';
  const url = args?.url?.value ? formatLexicalUrl(args.url.value) : null;

  let message = `Make ${method?.toUpperCase()} request`;

  if (url) {
    const maxUrlLength = 50;
    const displayUrl = url.length > maxUrlLength ? `${url.substring(0, maxUrlLength)}...` : url;
    message += ` to ${displayUrl}`;
  }

  return message;
};

export default evaluateHttpRequestMessage;
